import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { memo } from 'react';

import { dateFnsLocaleMap } from '../hooks/useDateFnsFormat';
import { useIntlValue } from './IntlContext';

export const DateFnsProvider = memo(({ children }) => {
    const locale = useIntlValue('locale');

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={dateFnsLocaleMap[locale]}>
            {children}
        </LocalizationProvider>
    );
});
